export default __webpack_public_path__ + "dcdc00580a0b29bdd9932cd2bd8d1eb6.svg";